import { Row, Col } from 'antd';
import './SectionForm.css';


const SectionForm = ({ value = [], onChange }) => {
  const handleSectionChange = (idx, field, fieldValue) => {
    const updated = [...value];
    updated[idx] = {
      ...updated[idx],
      [field]: fieldValue,
    };
    onChange(updated);
  };

  const handleBlockChange = (sectionIdx, blockIdx, field, fieldValue) => {
    const updated = [...value];
    const section = updated[sectionIdx];
    const blocks = section.blocks || [];
    blocks[blockIdx] = {
      ...blocks[blockIdx],
      [field]: fieldValue,
    };
    section.blocks = blocks;
    onChange(updated);
  };

  const handleRowChange = (sectionIdx, blockIdx, rowIdx, field, fieldValue) => {
    const updated = [...value];
    const rows = updated[sectionIdx]?.blocks?.[blockIdx]?.rows || [];
    rows[rowIdx] = {
      ...rows[rowIdx],
      [field]: fieldValue,
    };
    updated[sectionIdx].blocks[blockIdx].rows = rows;
    onChange(updated);
  };

  const addSection = () => onChange([...value, { name: '', price: '', blocks: [] }]);

  const removeSection = (idx) => {
    const updated = [...value];
    updated.splice(idx, 1);
    onChange(updated);
  };

  const addBlock = (sectionIdx) => {
    const updated = [...value];
    updated[sectionIdx].blocks = [...(updated[sectionIdx].blocks || []), { name: '', order: '', rows: [] }];
    onChange(updated);
  };

  const removeBlock = (sectionIdx, blockIdx) => {
    const updated = [...value];
    updated[sectionIdx].blocks.splice(blockIdx, 1);
    onChange(updated);
  };

  const addRow = (sectionIdx, blockIdx) => {
    const updated = [...value];
    updated[sectionIdx].blocks[blockIdx].rows = [...(updated[sectionIdx].blocks[blockIdx].rows || []), { name: '', order: '', total_seats: '' }];
    onChange(updated);
  };

  const removeRow = (sectionIdx, blockIdx, rowIdx) => {
    const updated = [...value];
    updated[sectionIdx].blocks[blockIdx].rows.splice(rowIdx, 1);
    onChange(updated);
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        {value.map((section, sectionIdx) => (
          <Col xs={24} md={12} lg={8} key={sectionIdx}>
            <div style={{ border: '1px solid #ccc', padding: 16, borderRadius: 8 }}>
              <Row gutter={[8, 8]}>
                <Col xs={24} md={12}>
                  <label>Section Name</label>
                  <input
                    type="text"
                    value={section.name || ''}
                    onChange={(e) => handleSectionChange(sectionIdx, 'name', e.target.value)}
                    required
                    style={{ width: '100%' }}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <label>Price</label>
                  <input
                    type="number"
                    value={section.price || ''}
                    onChange={(e) => handleSectionChange(sectionIdx, 'price', e.target.value)}
                    required
                    style={{ width: '100%' }}
                  />
                </Col>
              </Row>

              <div style={{ marginTop: 0 }}>
                <button type="button" onClick={() => addBlock(sectionIdx)} className="custom-btn section-btn">Add Block</button>
                {section.blocks?.map((block, blockIdx) => (
                  <div key={blockIdx} style={{ padding: 10, border: '1px dashed #aaa', marginTop: 10 }}>
                    <Row gutter={[8, 8]}>
                      <Col xs={24} md={12}>
                        <label>Block Name</label>
                        <input
                          type="text"
                          value={block.name || ''}
                          onChange={(e) => handleBlockChange(sectionIdx, blockIdx, 'name', e.target.value)}
                          required
                          style={{ width: '100%' }}
                        />
                      </Col>
                      {/* <Col xs={24} md={12}>
                        <label>Order</label>
                        <input
                          type="number"
                          value={block.block_order}
                          onChange={(e) => handleBlockChange(sectionIdx, blockIdx, 'block_order', e.target.value)}
                          required
                          style={{ width: '100%' }}
                        />
                      </Col> */}
                    </Row>

                    <div style={{ marginTop: 0 }}>
                      <button type="button" onClick={() => addRow(sectionIdx, blockIdx)} className="custom-btn row-btn">Add Row</button>
                      {block.rows?.map((row, rowIdx) => (
                        <div key={rowIdx} style={{ marginTop: 10 }}>
                          <Row gutter={[8, 8]}>
                            <Col xs={24} md={8}>
                              <label>Row Name</label>
                              <input
                                type="text"
                                value={row.name || ''}
                                onChange={(e) => handleRowChange(sectionIdx, blockIdx, rowIdx, 'name', e.target.value)}
                                required
                                style={{ width: '100%' }}
                              />
                            </Col>
                            {/* <Col xs={24} md={8}>
                              <label>Order</label>
                              <input
                                type="number"
                                value={row.row_order}
                                onChange={(e) => handleRowChange(sectionIdx, blockIdx, rowIdx, 'row_order', e.target.value)}
                                required
                                style={{ width: '100%' }}
                              />
                            </Col> */}
                            <Col xs={24} md={8}>
                              <label>Total Seats</label>
                              <input
                                type="number"
                                value={row.total_seats || ''}
                                onChange={(e) => handleRowChange(sectionIdx, blockIdx, rowIdx, 'total_seats', e.target.value)}
                                required
                                style={{ width: '100%' }}
                              />
                            </Col>
                          </Row>
                          <button type="button" onClick={() => removeRow(sectionIdx, blockIdx, rowIdx)}  className="custom-btn remove-btn">Remove Row</button>
                        </div>
                      ))}
                    </div>
                    <button type="button" onClick={() => removeBlock(sectionIdx, blockIdx)}  className="remove-block-btn" style={{marginTop: 5}}>Remove Block</button>
                  </div>
                ))}
              </div>
              {/* <button type="button" onClick={() => removeSection(sectionIdx)} style={{ marginTop: 12 }} className="remove-block-btn" >Remove Section</button> */}
            </div>
          </Col>
        ))}
      </Row>
      <div style={{ marginTop: 16 }}>
        <button type="button" onClick={addSection}  className="custom-btn section-btn">Add Section</button>
      </div>
    </div>
  );
};

export default SectionForm;
